import ngFileSaver from 'angular-file-saver';
import { FileResponse } from './fileResponse';

export default angular
  .module('ng1-response', [ngFileSaver])
  .service('fileResponseService', FileResponse)
  .name;
